import type { CourseModule } from "@/core/types";
import { lektionLinks } from "./lektion-01-links";
import { lektionMedien } from "./lektion-02-medien";

/**
 * Hyperlinks (PowerPointApi 1.6), interaktive Schaltflächen, Aktionen und die
 * Wiedergabe von Medien. Aktionen und Wiedergabeeinstellungen kennt nur VBA.
 */
export const modulInteraktiv: CourseModule = {
  id: "interaktiv",
  title: "Links, Medien und interaktive Folien",
  summary:
    "Hyperlinks mit sprechendem Text, interaktive Schaltflächen und Aktionen, " +
    "eingebettete Videos mit automatischer Wiedergabe.",
  level: "Aufbau",
  lessons: [lektionLinks, lektionMedien],
};
